export default {
    LOAD_ORDERS_BY_MONTH (state, deashboard) {
        state.items = deashboard
    }
}